module.exports = __webpack_public_path__ + "img/finance3.824a7fc1.png";